import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainID() {
  const articleData = {
    title: 'Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? (AI Menjelaskannya)',
    description: 'Merasa terkuras secara emosional karena teks? Pelajari bagaimana AI Toxic Detector mendeteksi komunikasi sepihak dan pola pengurasan emosi halus dalam hubungan Anda.',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa itu pengurasan emosi dalam hubungan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Pengurasan emosi terjadi ketika interaksi dengan seseorang secara konsisten membuat Anda merasa lelah, frustrasi, atau bersalah, seringkali karena komunikasi sepihak atau manipulatif.'
      }
    }, {
      '@type': 'Question',
      name: 'Bagaimana SMS bisa menyebabkan pengurasan emosi?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Pesan sepihak yang berulang, rasa bersalah, keterlibatan yang tidak konsisten, atau kritik halus dapat membuat Anda lelah, bahkan tanpa konflik besar.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah AI mendeteksi siapa yang menguras energi emosional saya?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Toxic Detector menganalisis pola teks, nada, dan keterlibatan untuk menyoroti perilaku sepihak, manipulatif, atau menguras secara instan.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    },
    datePublished: articleData.publishDate,
    dateModified: articleData.publishDate,
    url: `https://toxicdetector.com/id/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke papan klip!');
    }
  };
  return <>
      <MetaTags title="Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? — AI Menjelaskan Pengurasan Emosi | ToxicDetector" description="Merasa terkuras secara emosional karena teks? Pelajari bagaimana AI Toxic Detector mendeteksi komunikasi sepihak dan pola pengurasan emosi halus." keywords="pengurasan emosi dalam hubungan, pola teks sepihak, vampir energi, analisis emosional AI" canonical={`https://toxicdetector.com/id/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-6657" data-mp="2bp7ob927dmgm" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-6658" data-mp="1jwm9o3smmela">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-6659" data-mp="1nyh9t4ytmlxh">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-6660" data-mp="3lo8tnle3p989">
            <div className="flex items-center justify-between" data-id="element-6661" data-mp="3lptnt9wi6q5l">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-6662" data-mp="3ppaug6no1tcc">
                <span className="text-2xl" data-id="element-6663" data-mp="3prnj12nxj1yd">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-6664" data-mp="2ueco5buoj1to">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-6665" data-mp="34e3hha7i7as6">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-6666" data-mp="34bhd1jfwtbe6">
                  Pindai Gratis
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-6667" data-mp="2lezd4eqwq56u">
                  <Share2 size={20} className="text-gray-600" data-id="element-6668" data-mp="1syez6w572zxp" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-6669" data-mp="1nzbrf3xtyfm1">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-6670" data-mp="3gi1mqs4xnlm">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-6671" data-mp="3qmir8uql35qp" />
            Kembali ke Beranda
          </Link>

          <header className="mb-16" data-id="element-6672" data-mp="3ulhw6fcbf2i5">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-6673" data-mp="m7smorb6j65l">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-6674" data-mp="r4rf95f7351o">
              <time dateTime={articleData.publishDate} data-id="element-6675" data-mp="d72zgbzzio3h">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-6676" data-mp="32xfzgu28jwih">•</span>
              <span data-id="element-6677" data-mp="18g6jcg5c7z9m">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-6678" data-mp="18iajcn048e4m">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="AI menganalisis pola pengurasan emosi dalam pesan teks" className="w-full rounded-2xl shadow-lg" data-id="element-6679" data-mp="13h3b6mu29cxf" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-6680" data-mp="ppopu9cokzn7">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-6681" data-mp="kqvfgpsoxor9">Daftar Isi</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-6682" data-mp="ksyefzbtms84">
              <li data-id="element-6683" data-mp="fsan1cjok9dd">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-6684" data-mp="ftv88bk3ufyk">
                  Teman "Selalu Ada yang Salah"
                </a>
              </li>
              <li data-id="element-6685" data-mp="265jbv1yjang4">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-6686" data-mp="264zsdgt8jqzz">
                  Orang yang Hanya Mengirim Pesan Saat Butuh Sesuatu
                </a>
              </li>
              <li data-id="element-6687" data-mp="1njrufwiqpi1">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-6688" data-mp="1n1x5npi8jc8">
                  "Dry-Texter" Emosional
                </a>
              </li>
              <li data-id="element-6689" data-mp="3a1k23gk5firm">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-6690" data-mp="3a33h73u2jnrt">
                  Artis Ghost & Return
                </a>
              </li>
              <li data-id="element-6691" data-mp="3j0dueuqg5mzd">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-6692" data-mp="tdok10qisgtt">
                  Pembuat Rasa Bersalah Halus
                </a>
              </li>
              <li data-id="element-6693" data-mp="a0h5oxoi1et6">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-6694" data-mp="9xl4n0hcua0i">
                  Pendukung Palsu
                </a>
              </li>
              <li data-id="element-6695" data-mp="e1apbeuws7g9">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-6696" data-mp="e0r8y2kwpr4c">
                  Kombo "Sehat-Beracun"
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-6697" data-mp="11q3pxomh73h7">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-6698" data-mp="11osk7j9gzlng">
              Pernah mengirim pesan kepada seseorang dan merasa lelah, kesal,
              atau anehnya bersalah sesudahnya, bahkan jika percakapan itu bukan
              pertengkaran? Itu adalah{' '}
              <strong className="text-gray-900" data-id="element-6699" data-mp="2zizi9em978og">
                pengurasan emosi dalam hubungan
              </strong>
              , dan itu lebih umum daripada yang Anda pikirkan.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-6700" data-mp="2tgo13ye2xee5">
              Itu adalah{' '}
              <strong className="text-gray-900" data-id="element-6701" data-mp="2flc3nj8jh9tj">pola teks sepihak</strong> dan
              manipulasi halus.{' '}
              <strong className="text-gray-900" data-id="element-6702" data-mp="25oz2y1ektvpa">Analisis AI</strong> kami
              membaca pola-pola ini secara instan.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-6703" data-mp="2ap4yvtrvq4d6">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6704" data-mp="1wokfave544im">
                1️⃣ Teman "Selalu Ada yang Salah"
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6705" data-mp="21nnkcfu4eaql">
                Anda memeriksa ponsel Anda dan langsung merasa:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-6706" data-mp="3w1y4wc3omiqk">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-6707" data-mp="g9hrhrh75nfj">
                  "Ya Tuhan... apa lagi sekarang?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6708" data-mp="l2t283p4qocq">
                Setiap pesan adalah stres, kekacauan, atau keluhan. AI menandai
                ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-6709" data-mp="bbgbxgizc68t">
                  beban emosional sepihak
                </strong>
                .
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-6710" data-mp="13yj65wgmhut9">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6711" data-mp="q02yo3axs0a2">
                2️⃣ Orang yang Hanya Mengirim Pesan Saat Butuh Sesuatu
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-6712" data-mp="v10ewacdyk8x">
                <p className="mb-4 text-lg text-gray-700" data-id="element-6713" data-mp="3aoqpzcdft745">
                  <strong className="text-gray-900" data-id="element-6714" data-mp="3fpeosk7wqs8x">Tidak pernah:</strong> "Apa
                  kabar?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-6715" data-mp="376jg812rfmhl">
                  <strong className="text-gray-900" data-id="element-6716" data-mp="336ss654mbkgr">Selalu:</strong> "Bisakah
                  kamu...?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6717" data-mp="3h5s6ojyf2iz7">
                AI mendeteksi ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-6718" data-mp="3c80d7li4iosw">
                  komunikasi transaksional
                </strong>
                .
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-6719" data-mp="2jjusuzuzf1tl">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6720" data-mp="2y765z66tatvt">
                3️⃣ "Dry-Texter" Emosional
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-6721" data-mp="2tf4wtt4xxja0">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-6722" data-mp="25pu3gwpx6r5w">
                  "ok."
                  <br data-id="element-6723" data-mp="20r92gv2ug3ge" />
                  "K."
                  <br data-id="element-6724" data-mp="20q7nifipiwte" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-6725" data-mp="4mt81hu44jgb">
                AI menangkap{' '}
                <strong className="text-gray-900" data-id="element-6726" data-mp="9lnr8kvzsa0y">sinyal pemutusan</strong> ini
                secara instan.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-6727" data-mp="if960485prad">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6728" data-mp="3hvfjxty0vqws">
                4️⃣ Artis Ghost & Return
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6729" data-mp="3mvk3jsu891r8">
                Menghilang selama 3 minggu. Kembali seperti:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-6730" data-mp="3vv73093ebxhn">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-6731" data-mp="3vsudnavb6kuk">
                  "haaaai 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6732" data-mp="1b46mc1st5e0h">
                AI menandai ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-6733" data-mp="1l7ldvp09gc4m">
                  keterlibatan yang tidak konsisten
                </strong>
                .
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-6734" data-mp="1bibo4fsw35jo">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6735" data-mp="1bgqtkq6krmlt">
                5️⃣ Pembuat Rasa Bersalah Halus
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-6736" data-mp="12j81j1uik80f">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-6737" data-mp="xiak4rhbvhzz">
                  "Kurasa aku akan pergi sendiri saja..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-6738" data-mp="oixanyt7etf9">
                AI menandai ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-6739" data-mp="2myjt0nvsmsyi">manipulasi pasif</strong>.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-6740" data-mp="2ixzv3i3eblbb">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6741" data-mp="2q04qd409loll">
                6️⃣ Pendukung Palsu
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-6742" data-mp="2uxn2125o2hxa">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-6743" data-mp="2gy58yalc8ii4">
                  "Maksudku, kamu memang cenderung bereaksi berlebihan
                  kadang-kadang."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6744" data-mp="277sqcnx32zem">
                AI mendeteksi{' '}
                <strong className="text-gray-900" data-id="element-6745" data-mp="2c1oivaukvu2e">kritik terselubung</strong>.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-6746" data-mp="1x94lkqu40gsv">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6747" data-mp="22b29vzhda1so">
                7️⃣ Kombo "Sehat-Beracun"
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-6748" data-mp="1ocvnbfhvbo8b">
                <p className="mb-4 text-lg text-gray-700" data-id="element-6749" data-mp="1tbowwwu1av37">
                  Beberapa hari hangat. Beberapa hari dingin.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-6750" data-mp="14praun78y5kh">
                AI melabeli pola ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-6751" data-mp="1iptotycfoeug">
                  ritme emosional yang tidak stabil
                </strong>
                .
              </p>
            </section>

            <section className="mb-16" data-id="element-6752" data-mp="1sldgg8jysrde">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6753" data-mp="1nnlgcr961yy4">
                Mengapa Ini Penting
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-6754" data-mp="22bg9u9v007c9">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-6755" data-mp="1xdwxjfhv24my">
                  Setelah Anda melihat polanya, Anda dapat:
                </p>
                <ul className="space-y-5" data-id="element-6756" data-mp="26ecwqcrkmpm0">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-6757" data-mp="26fecuvng22al">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-6758" data-mp="141q5k7ji70m4">
                      ✓
                    </span>
                    <span data-id="element-6759" data-mp="19000qi58a17q">Melindungi energi Anda</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-6760" data-mp="1d0jzfq5g9cvz">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-6761" data-mp="1hsbofw8yjak0">
                      ✓
                    </span>
                    <span data-id="element-6762" data-mp="1mqwsy7v8sge9">Menetapkan batasan</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-6763" data-mp="1rp6qgp4fvt31">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-6764" data-mp="1wosy8j1i0h4g">
                      ✓
                    </span>
                    <span data-id="element-6765" data-mp="20qeb44e18ven">Berhenti merasa bersalah</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-6766" data-mp="6cww55rp16v8">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-6767" data-mp="6dog1jbxhg5o">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-5" data-id="element-6768" data-mp="3q81nczgzsord">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-6769" data-mp="3l8p38mhi9vsh" data-mpi={index}>
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-6770" data-mp="hrzuctuga9zn">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-6771" data-mp="cu81nxlzejue">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-6772" data-mp="3utep850wren">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-6773" data-mp="2tffzukbmg8gj">
              😮‍💨 Berhenti Merasa Terkuras.
              <br data-id="element-6774" data-mp="sfbe1r10ydv8" />
              Mulai Melihat dengan Jelas.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-6775" data-mp="wgwo74m6ce1q">
              Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
              skor toksisitas instan.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-6776" data-mp="nforus37xnaa">
              <p className="font-bold text-2xl" data-id="element-6777" data-mp="1b73wirigwgop">
                "⚠️ Pengurasan Emosi: Tinggi. Komunikasi sepihak terdeteksi."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-6778" data-mp="11g97jfdu72zk">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <div className="mt-20" data-id="element-6779" data-mp="1yvdgdnw4eud7">
            <RelatedBlogPosts posts={[{
            title: 'Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? Bagian 2',
            description: 'Pola yang lebih halus yang menguras energi Anda, termasuk penjelasan berlebihan dan sok tahu.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: 'Panduan Utama Teks Pasif-Agresif',
            description: 'Temukan perilaku pasif-agresif dan manipulasi tersembunyi dalam pesan teks.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-6780" data-mp="1ywf00gr7cp6j" />
          </div>

          <div className="mt-16 text-center" data-id="element-6781" data-mp="34o02irggw7wz">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-6782" data-mp="oxncv5u3y5a1">
              <Share2 size={20} data-id="element-6783" data-mp="9odgmfylvplk" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-6784" data-mp="4rmyln38qjxi">
          <div className="max-w-4xl mx-auto px-6" data-id="element-6785" data-mp="jnvxuon4sx9x">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-6786" data-mp="jonpjodlyaux">
              <p className="text-gray-400 text-sm" data-id="element-6787" data-mp="engkhx2unpry">
                © {new Date().getFullYear()} ToxicDetector. Hak cipta
                dilindungi undang-undang.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}